import { Reveal, Overline } from "@/components/Reveal";

export default function About({ content }) {
  const pillars = content.pillars || [];
  return (
    <section id="about" data-testid="about-section" className="bg-chalk py-20 sm:py-28 lg:py-36">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <Overline>{content.about_overline}</Overline>
              <h2 className="mt-6 font-serif font-bold tracking-tight text-navy text-3xl sm:text-4xl lg:text-5xl leading-[1.1]" data-testid="about-title">
                {content.about_title}
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-7 lg:pt-14">
            <Reveal delay={0.15}>
              <p className="text-base sm:text-lg font-sans text-navy/85 leading-relaxed" data-testid="about-description">
                {content.about_description}
              </p>
              <p className="mt-5 text-base font-sans text-[#5B6B7C] leading-relaxed">
                {content.about_description_2}
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 sm:mt-24 grid grid-cols-1 md:grid-cols-3 gap-x-10 gap-y-12">
          {pillars.map((p, i) => (
            <Reveal key={i} delay={0.1 + i * 0.12}>
              <div className="border-t-2 border-navy/15 pt-6 group" data-testid={`about-pillar-${i}`}>
                <span className="font-mono text-xs tracking-[0.3em] text-cherry">0{i + 1}</span>
                <h3 className="mt-3 font-serif text-2xl font-semibold text-navy group-hover:text-cherry transition-colors duration-300">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm font-sans text-[#5B6B7C] leading-relaxed">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
